import { TDivergenceSearchProps } from 'open-search/types';
import { TextsSearchTrucker } from '../types';

export function useDivergenceSearch() {
  const openWhatsApp = () => {
    window.open(TextsSearchTrucker.textWhatsAppCustomerServiceUrl, '_blank');
  };

  const propsDivergenceSearch: TDivergenceSearchProps = {
    contactCustomerServiceButtonProps: {
      states: { textContent: TextsSearchTrucker.textButtonContactCustomerService },
      events: {
        onClick: () => openWhatsApp(),
      },
    },
  };

  return { propsDivergenceSearch };
}
